const getTimeAttemptedForAudioTranscription = (examGuid) => {
  let hexSum = 0;
  examGuid.split("").forEach((char) => {
    if (char !== "-") {
      hexSum += parseInt(char, 16);
    }
  });

  return getFormattedDateNoMillis() + `.${hexSum}`;
};

export default getTimeAttemptedForAudioTranscription;

function getFormattedDateNoMillis(date = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // 0-indexed
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
